<header class="sticky" [class.fixed]="stick && sticky">
  <div class="mobile-fix-option"></div>

  <div class="top-header" *ngIf="topbar">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="header-contact"></div>
        </div>
        <div class="col-lg-6 text-end">
          <ul class="header-dropdown"></ul>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="col-sm-12">
      <div class="main-menu">
        <div class="menu-left">
          <app-left-menu></app-left-menu>
          <div class="brand-logo">
            <a routerLink="/" id="headerlogo">
              <img
                [src]="themeLogo"
                class="img-fluid mega-site-header__logo"
                alt="Mega móvil"
                width="300"
                height="90"
                fetchpriority="high"
                decoding="sync"
              />
            </a>
          </div>
        </div>
        <div class="menu-right pull-right">
          <div><app-menu></app-menu></div>
          <div class="cont-signin">
            <ul class="header-dropdown">
              <li class="onhover-dropdown mobile-account iniciar-sesion">
                <div class="iniciar-sesion__trigger" aria-hidden="true">
                  <i class="ti-user"></i>
                  <span class="btn-iniciar">{{ btnIniciar }}</span>
                </div>
                <ul class="onhover-show-div">
                  <li *ngIf="usuario == null" class="border border_bot">
                    <a data-lng="en" [routerLink]="['/pages/login']">Mi Cuenta MEGA</a>
                  </li>
                  <li *ngIf="usuario == null">
                    <a
                      data-lng="en"
                      href="https://mctecbazar.ddns.net:8443/account/login"
                      target="_blank"
                      rel="noopener noreferrer">
                      Administración
                    </a>
                  </li>
                  <li *ngIf="usuario != null" class="border border_bot">
                    <a data-lng="en" [routerLink]="['/pages/dashboard']">Mi Cuenta</a>
                  </li>
                  <li *ngIf="usuario != null" class="menu-cuenta-pedidos">
                    <a data-lng="en" [routerLink]="['/pages/pedidos']">Mis Pedidos</a>
                  </li>
                  <li *ngIf="usuario != null" class="menu-cuenta-deseos">
                    <a data-lng="en" [routerLink]="['/shop/wishlist']">Mis Deseos</a>
                  </li>
                  <li *ngIf="usuario != null" class="border border_top">
                    <a data-lng="en" href="javascript:void(0)" (click)="logout($event)">Cerrar Sesión</a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div><app-settings></app-settings></div>
        </div>
      </div>
    </div>
  </div>
</header>
